module.exports = __webpack_public_path__ + "cloud-4.svg?dd4d14a27e8e7e6862068ef48b0fbd99";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-4.svg
// module id = 42
// module chunks = 0